import axios from 'axios';
import { useState, useCallback } from 'react';
import { useNotifications } from '@toolpad/core/useNotifications';

import { useAlert } from 'hooks/alert';
import { downloadBlob } from 'utils/file';

export const useDownloadFile = () => {
  const { handleError } = useAlert();
  const notifications = useNotifications();
  const [isLoading, setLoading] = useState(false);

  const downloadFile = useCallback(
    async (path: string, name?: string) => {
      const id = notifications.show(`Downloading file ${name}...`);
      try {
        setLoading(true);

        const response = await axios({
          url: path,
          method: 'GET',
          responseType: 'blob',
          headers: { Accept: '*/*' },
        });

        downloadBlob(response.data, name || 'filename');
      } catch (error) {
        console.error(error);
        handleError(error);
      } finally {
        notifications.close(id);
        setLoading(false);
      }
    },
    [handleError, notifications]
  );

  return { isLoading, downloadFile };
};
